import { ChangeDetectionStrategy, Component, inject, input, output } from "@angular/core";
import { AnchorUISref, UISref } from "@uirouter/angular";
import { TrackingService } from "app/commons/services/tracking.service";
import { IUserProfile } from "app/types/user";

@Component({
  selector: "op-user-actions",
  templateUrl: "./opUserActions.view.html",
  styleUrl: "./opUserActions.style.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    UISref,
    AnchorUISref
  ]
})
export class OpUserActions {

  protected readonly _tracking = inject(TrackingService);
  public readonly user = input<IUserProfile>();
  public readonly onLogout = output<void>();

}
